import { log } from 'log';
import { useCallback } from 'react';

import * as Types from '../types';
import { validateGeolocation } from 'js/hooks/auth/pas';
import { useUserSelector } from 'js/store/hooks';
import { path } from 'ramda';

export const useXpointLiteRequestPacket = ({
    sdk,
    transactionID,
    geolocationType,
    receivePacket
}: {
    sdk: Types.XPointLiteSDKInstance | null;
    transactionID: string | null;
    geolocationType: string;
    receivePacket: Types.ReceivePacketCallback;
}) => {
    const userId: string = useUserSelector(path(['userDetails', 'userId'])) ?? '';

    return useCallback(async () => {
        if (!sdk) {
            return;
        }

        const response = await validateGeolocation(null, null, null, null, null, geolocationType);
        const sessionValidationData = response.data.sessionValidationData || {};
        const sessionValidationByGeolocationData = sessionValidationData.SessionValidationByGeolocationData || [];
        const geolocationData = sessionValidationByGeolocationData[0] || {};
        const {
            clientId,
            clientBrand,
            jurisdictionAreaId,
            jurisdictionAreaName,
            customData,
            sessionHash
        } = Object.fromEntries(geolocationData.properties?.map(({
            key,
            value
        }: {
            key: string;
            value: string;
        }) => {
            return [key, value];
        }) ?? []);

        const checkResult = await sdk.liteCheck({
            userId,
            client: clientId,
            clientBrand,
            customData,
            jurisdictionArea: {
                id: jurisdictionAreaId,
                name: jurisdictionAreaName
            },
            sessionId: sessionHash ?? ''
        });

        log('gcReq', {
            transactionID
        });

        await receivePacket(checkResult.jwt, transactionID);
    }, [
        sdk,
        userId,
        transactionID,
        geolocationType,
        receivePacket
    ]);
};
